import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RoundButton from '../components/roundButton';
import MemberComponent from '../components/memberComponent';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import EditModalManifold from '../components/editModalManifold';
import { allSegments } from '../../services/tactonService';
import {
  commitedUIMembers,
  getSegmentSeriesUIGroup,
  getSegmentSeriesUIMembers,
  getSegmentUIGroupMember
} from '../../services/cadService';

import {
  commitAssemblyManifold,
  unCommitAssemblyManifold,
  batchUncommit,
  batchCommitProductMember
} from '../../services/configuratorService';

import { getStepMembers } from '../../services/tactonService';
import {
  SetCommitsName,
  getIndex
} from '../../services/facetInteractionService';

import { getPossibleImages } from '../../services/imageSourceService';

function ManifoldAssemblyNav(props) {
  const {
    startData,
    sessionDataItems,
    handleOnChange,
    handleIsManifoldSegmentStepEdited,
    handleActiveTab,
    isVE,
    isManifoldSegmentStepEdited,
    activeTab,
    isStationEdit,
    handleIsStationEdit,
    editedStationMembers,
    handleEditeStationMembers,
    editedManifoldSegmentforPrice,
    handleEditedManifoldSegmentforPrice,
    handleManifoldPrices,
    handleRemovePrice,
    editedWorkStation,
    handleEditedWorkStation,
    handleDeleteSegmentEdited,
    commits,
    handleSetCommits,
    handleCurrentSegmentName,
    lang,
    handleIsCADValueChanged
  } = props;
  const [selectedOption, setSelectedOption] = useState(0);
  const [editData, setEditData] = useState();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [currentEditingStation, setCurrentEditingStation] = useState();
  const [tactonModel, setTactonModel] = useState();
  const [segmentDuplicateStatus, setSegmentDuplicateStatus] = useState([]);

  useEffect(() => {
    handleActiveTab(startData?.manifoldStep?.name);
  }, []);

  useEffect(() => {
    let members = currentWorkstationMembers(currentEditingStation, startData);
    setEditData(members);
  }, [startData]);

  useEffect(() => {
    //Logic to check whether duplicate button is visible or not
    if (selectedOption === 1) {
      setSegmentDuplicateStatus([]);
      const updatedState = [];
      allSegments(startData).map(async workstation => {
        if (ifCurrentWorkStationHaveMembers(workstation)) {
          let isDuplicateEnable = await canDupManipulateWorkstations(
            workstation.name
          );

          setSegmentDuplicateStatus(prevItems => [
            ...prevItems,
            { name: workstation.name, isDuplicate: isDuplicateEnable }
          ]);
        }
      });
    }
  }, [selectedOption]);

  const onManifoldValeOptionsClick = () => {
    setSelectedOption(0);
    handleIsManifoldSegmentStepEdited(false);
    handleActiveTab(startData?.manifoldStep?.name);
  };

  const onValveStationClick = () => {
    setSelectedOption(1);
    handleIsManifoldSegmentStepEdited(false);
    handleActiveTab(startData?.segmentStep?.name);
    checkCommitsforIcons();
  };

  //get the current segment selection group from previous segment group
  const currentSegmentSelectionGroup = (segment, response) => {
    //get the current segment group index
    var currentSegmentRootGroupIndex =
      response?.segmentStep.rootGroup.members.findIndex(x =>
        x.name.includes(segment.name)
      );
    //get selection group from prev segment group
    var prevSegmentRootGroup =
      response?.segmentStep.rootGroup.members[currentSegmentRootGroupIndex - 1];
    return prevSegmentRootGroup.members.filter(x =>
      x.name.includes('selection')
    );
  };
  //get the current segment selection members from previous segment group
  const currentSegmentSelectionMembers = (segment, response) => {
    var selectionMemberGroup = currentSegmentSelectionGroup(segment, response);
    //return current segment selection members
    return selectionMemberGroup[0].members.filter(
      x => !x.name.includes('add_segment')
    );
  };

  const ifCurrentWorkStationHaveMembers = segment => {
    var currentStationMembers = getSegmentUIGroupMember(segment);
    return currentStationMembers.length > 0;
  };

  const stationPartnumber = segment => {
    var infoMemberGroup = segment.members.filter(x =>
      x.name.includes('info_group')
    );
    var seriesInfoGroup = infoMemberGroup[0].members.filter(
      x => x.properties == undefined || x.properties['hidden'] != 'yes'
    );
    var partNumberAddtoParent = seriesInfoGroup[0].members.filter(
      x =>
        x.properties['ph_add_to_parent'] &&
        x.properties['ph_add_to_parent'] == 'yes' &&
        x.properties['hidden'] == 'no'
    );
    return partNumberAddtoParent;
  };

  const endSegment = segment => {
    var nextSegmentSelectionMemberGroup = nextSegmentSelectionGroup(segment);
    if (
      !nextSegmentSelectionMemberGroup ||
      nextSegmentSelectionMemberGroup?.length <= 0
    )
      return;
    var addAnotherSegmentMember =
      nextSegmentSelectionMemberGroup &&
      nextSegmentSelectionMemberGroup[0]?.members.filter(x =>
        x.name.includes('add_segment')
      );
    //if there is further more segments don't display this segments end of assembly controls
    if (
      addAnotherSegmentMember &&
      (addAnotherSegmentMember.length == 0 ||
        addAnotherSegmentMember[0]?.value == 'Yes')
    )
      return;
    return (
      nextSegmentSelectionMemberGroup &&
      nextSegmentSelectionMemberGroup[0]?.members.filter(
        x => !x.name.includes('add_segment')
      )
    );
  };

  const nextSegmentSelectionGroup = segment => {
    //next segment selection group
    return segment?.members?.filter(x => x.name.includes('selection'));
  };

  const checkCommitsforIcons = () => {
    var stations = allSegments(startData);
    for (var i = 0; i < stations.length; i++) {
      var commitedMembers = commitedUIMembers(stations[i]);
      commitedMembers = commitedMembers.filter(
        x => !x.name.includes('add_segment')
      );
      if (commitedMembers.length > 0) {
        setWorkstationEdited(stations[i].name, true);
      }
    }
  };

  const setWorkstationEdited = (name, value) => {
    handleEditedWorkStation(name, value);
  };

  const hasWorkstationEdits = name => {
    let isExist =
      editedWorkStation.filter(x => x.key == name)[0]?.value === true;
    return isExist;
  };

  const getManifoldStepName = () => {
    return startData?.manifoldStep?.name;
  };

  const canDupManipulateWorkstations = async segmentName => {
    if (isVE) return false;
    if (isSegmentCountDefined()) {
      var allActiveStations = allSegments(startData); //get all available work sections
      var startIndex = allActiveStations.findIndex(x => x.name === segmentName); //get index of duplicating work section
      var IsthislastsectionOnScreen =
        allActiveStations.length == startIndex + 1;
      if (IsthislastsectionOnScreen) return false;
      else return true;
    } else {
      let addRestrictionMet = await commitRestrictionAddressforHSeries(
        segmentName
      );
      if (addRestrictionMet) return false;
      return ifAddressLimitNotMet(segmentName);
    }
  };

  const commitRestrictionAddressforHSeries = async currentSegmentName => {
    let response = startData;
    var addressSegmentGroup = startData?.segmentStep.rootGroup.members.filter(
      x => x.name.includes('address')
    );
    var addressRestriction = 0;
    if (
      addressSegmentGroup.length > 0 &&
      addressSegmentGroup[0].properties &&
      addressSegmentGroup[0].properties['ph_address_restriction']
    )
      addressRestriction =
        +addressSegmentGroup[0].properties['ph_address_restriction'];
    else {
      return false;
    }
    var availableSegments = allSegments(startData);
    if (availableSegments.length <= 1) return false; //if only one segment available
    var maxPosition = availableSegments.length - 1;
    //get last segment address details
    var valveSeries = currentSegmentSeriesSelectionMemberLocal(
      availableSegments[maxPosition - 1],
      startData
    );
    //var lastAvailableSection = availableSegments[maxPosition];

    // total used segment address
    var totalSegmentAddressMember = addressSegmentGroup[0].members.filter(
      x =>
        x.name.includes('total_segment') &&
        (x.properties == undefined || x.properties['hidden'] != 'yes')
    );
    //commit the last segment address component if not commited for H3 Series
    if (currentSegmentName == availableSegments[maxPosition].name) {
      if (
        valveSeries.valueDescription.includes('H3') &&
        +totalSegmentAddressMember[0].value >= addressRestriction &&
        +totalSegmentAddressMember[0].value <= addressRestriction + 2
      ) {
        var currentStationUIMembers = getSegmentSeriesUIMembers(
          availableSegments[maxPosition]
        );
        var addressContributionField = currentStationUIMembers.filter(
          x => x.properties !== undefined && x.properties['ph_address'] == 'yes'
        );

        if (!addressContributionField[0].committed) {
          props.isLoading(true);
          response = await commitAssemblyManifold(
            createRequest(
              {
                key: addressContributionField[0].name,
                value: addressContributionField[0].value,
                isManifoldSegmentStepEdited: isManifoldSegmentStepEdited,
                step: activeTab,
                activeTab: activeTab
              },
              startData?.configState
            )
          );

          handleIsManifoldSegmentStepEdited(true);
          props.isLoading(false);

          props.handleStartData(response);
        }
      }
    }
    if (+totalSegmentAddressMember[0].value == addressRestriction) {
      return true;
    } else {
      return false;
    }
  };

  const ifAddressLimitNotMet = currentSegmentName => {
    if (currentSegmentName == '') return true;
    var availableSegments = allSegments(startData);
    if (availableSegments.length <= 1) return true; //if only one segment available
    var addressSegmentGroup = startData?.segmentStep.rootGroup.members.filter(
      x => x.name.includes('address')
    );
    var maxAddressMember = addressSegmentGroup[0].members.filter(x =>
      x.name.includes('max_address')
    ); //maximum allowed address
    if (+maxAddressMember[0].valueDescription == 0) return true; // return if there is no address restriction
    // total used segment address
    var totalSegmentAddressMember = addressSegmentGroup[0].members.filter(
      x =>
        x.name.includes('total_segment') &&
        (x.properties == undefined || x.properties['hidden'] != 'yes')
    );
    //allow not to add further more segments if max. address is reached
    if (
      +totalSegmentAddressMember[0].value ==
      +maxAddressMember[0].valueDescription
    )
      return false;
    //get current segment address details
    if (currentSegmentName.length > 0) {
      var currentSegmentAddressOutputName = currentSegmentName.replace(
        'ui_group',
        'address_output'
      );
      var currentSegmentOutputMember = addressSegmentGroup[0].members.filter(
        x => x.name.includes(currentSegmentAddressOutputName)
      );
      if (+currentSegmentOutputMember[0].value == 0) return false; //Intermediate valve
      if (+maxAddressMember[0].valueDescription == 0) return true;
      //Duplicate should not be shown for segments whose output address is greater that the maximum available limit
      if (
        +totalSegmentAddressMember[0].value +
          +currentSegmentOutputMember[0].value >
        +maxAddressMember[0].valueDescription
      ) {
        return false;
      } else return true;
    } else return true;
  };

  const canDeleteWorkstations = () => {
    if (isVE) return false;
    if (isSegmentCountDefined()) return false;
    let allSegment = allSegments(startData);
    return allSegment.length > 1;
  };

  const canAddWorkStation = () => {
    if (isVE) return false;
    if (isSegmentCountDefined()) return false;
    return ifAddressLimitNotMet('');
  };

  const onAddStationClick = async () => {
    props.isLoading(true);
    let response = startData;
    response = await addNewStation(response);
    props.handleStartData(response);
    handleIsCADValueChanged(true);
    props.isLoading(false);
  };

  const addNewStation = async response => {
    var availableSegments = allSegments(response);
    var lastAvailableSegment = availableSegments[availableSegments.length - 1];

    let configState = response.configState;

    response = await commitSegmentValveSelection(
      lastAvailableSegment,
      configState,
      response
    );
    response = await commitAddressContributionField(
      lastAvailableSegment,
      response
    );
    configState = response ? response.configState : configState;
    let res = await ifNextSegmentAvailableAddSegment(
      lastAvailableSegment,
      configState,
      response
    );
    response = res ? res : response;

    return response;
  };

  const commitAddressContributionField = async (segment, response) => {
    var addressSegmentGroup = response.segmentStep.rootGroup.members.filter(x =>
      x.name.includes('address')
    );
    if (
      addressSegmentGroup[0].properties &&
      addressSegmentGroup[0].properties['ph_address_restriction']
    ) {
      var currentStationUIMembers = getSegmentSeriesUIMembers(segment);
      var addressContributionField = currentStationUIMembers.filter(
        x => x.properties && x.properties['ph_address'] == 'yes'
      );
      if (
        addressContributionField.length > 0 &&
        !addressContributionField[0].committed
      ) {
        response = await commitAssemblyManifold(
          createRequest(
            {
              key: addressContributionField[0].name,
              value: addressContributionField[0].value,
              isManifoldSegmentStepEdited: true,
              step: activeTab,
              activeTab: activeTab
            },
            response?.configState
          )
        );
      }
    }
    return response;
  };

  const commitSegmentValveSelection = async (
    segment,
    configState,
    response
  ) => {
    var seriesSelection = currentSegmentSeriesSelectionMemberLocal(
      segment,
      response
    );
    if (seriesSelection && !seriesSelection.committed) {
      response = await commitAssemblyManifold(
        createRequest(
          {
            key: seriesSelection.name,
            value: seriesSelection.value,
            isManifoldSegmentStepEdited: isManifoldSegmentStepEdited,
            step: activeTab,
            activeTab: activeTab
          },
          configState
        )
      );

      handleIsManifoldSegmentStepEdited(true);
    }
    return response;
  };

  const ifNextSegmentAvailableAddSegment = async (
    segment,
    configState,
    response
  ) => {
    var addAnotherSegmentMember = nextSegmentAddSegmentMember(segment);
    if (
      addAnotherSegmentMember &&
      addAnotherSegmentMember.domain.elements.filter(
        x => x.description == 'Yes' && x.state == 'green'
      ).length > 0
    ) {
      var currentActiveStations = allSegments(response);
      response = await commitAssemblyManifold(
        createRequest(
          {
            key: addAnotherSegmentMember.name,
            value: 'Yes',
            isManifoldSegmentStepEdited: true,
            step: activeTab,
            activeTab: activeTab
          },
          configState
        )
      );

      var allActiveSection = allSegments(response);
      var stationIndex = allActiveSection.findIndex(
        x => x.name === segment.name
      );
      let segmentName = allActiveSection[stationIndex + 1].name;
      addEditedManifoldSegmentforPrice('manifold', currentActiveStations, true);
      addEditedManifoldSegmentforPrice(
        segmentName,
        currentActiveStations,
        false
      );
    }
    return response;
  };
  //get the next add to segment member from current segment group
  const nextSegmentAddSegmentMember = segment => {
    var nextSegmentSelectionMemberGroup = nextSegmentSelectionGroup(segment);
    return nextSegmentSelectionMemberGroup[0].members.filter(x =>
      x.name.includes('add_segment')
    )[0];
  };

  //get the current segment series selection from previous segment group
  const currentSegmentSeriesSelectionMemberLocal = (segment, response) => {
    var selectionMemberGroup = currentSegmentSelectionMembers(
      segment,
      response
    );
    //return current segment series selection
    return selectionMemberGroup.filter(
      x => x.properties && x.properties['ph_series_selection'] == 'yes'
    )[0];
  };

  //get the currect add to segment member from previous segment group
  const currentSegmentAddSegmentMember = (segment, response) => {
    var selectionMemberGroup = currentSegmentSelectionGroup(segment, response);
    return selectionMemberGroup[0].members.filter(x =>
      x.name.includes('add_segment')
    )[0];
  };

  const onDeleteWorkstationClick = async segment => {
    props.isLoading(true);
    var currentCommits = [];
    var configState = startData.configState;
    var response = startData;
    var currentUIandSelectionCommits = [];
    handleIsCADValueChanged(true);
    var allActiveSection = allSegments(startData);
    var stationIndex = allActiveSection.findIndex(x => x.name === segment.name); //get deleting section index
    var Isthislastsection = allActiveSection.length == stationIndex + 1;
    var deleteCommits = commitedUIMembers(segment); //Get the commits from the section to be deleted.
    //uncommit all the selections before deleting/hide
    if (deleteCommits.length > 0) {
      let requestData = {
        divisionId: sessionDataItems?.manufacturingDivision,
        productId: '',
        configState: response?.configState,
        key: '',
        configModel: sessionDataItems?.configModel,
        commits: deleteCommits.map(x => x.name),
        step: activeTab,
        activeTab: activeTab //,
        //tactonModel: response.tactonModel
      };
      let res = await batchUncommit(requestData);
      response = res ? res : response;
      configState = response ? response.configState : configState;

      handleDeleteSegmentEdited(segment.name);
    }

    //Check if this is the last section on screen to click. if yes, we don't have to loop through all the sections
    if (Isthislastsection) {
      response = await hideLastSection(
        allActiveSection[stationIndex],
        response
      );
    } else {
      for (var i = stationIndex + 1; i < allActiveSection.length; i++) {
        currentUIandSelectionCommits = [];
        //get the current commits before uncommit
        currentCommits = commitedUIMembers(allActiveSection[i]);
        currentUIandSelectionCommits.push(...currentCommits);
        //get the series selection and if commited, uncommti it
        var seriesSelection = currentSegmentSeriesSelectionMemberLocal(
          allActiveSection[i],
          response
        );
        if (seriesSelection.committed)
          currentUIandSelectionCommits.push(seriesSelection);

        //Uncommit the selections in this section.
        if (currentUIandSelectionCommits.length > 0) {
          let requestData = {
            divisionId: sessionDataItems?.manufacturingDivision,
            productId: '',
            configState: configState,
            key: '',
            step: activeTab,
            activeTab: activeTab,
            //tactonModel: response.tactonModel,
            configModel: sessionDataItems?.configModel,
            commits: currentUIandSelectionCommits.map(x => x.name)
          };
          let res = await batchUncommit(requestData);
          response = res ? res : response;
          configState = response ? response.configState : configState;
        }
        if (currentCommits.length > 0)
          handleEditeStationMembers(allActiveSection[i].name);
        var checkagainforlastsection = allActiveSection.length == i + 1;
        //If this is the last section, then just hide it.
        if (checkagainforlastsection) {
          response = await hideLastSection(allActiveSection[i], response);
        }
        response = await batchcommitSegmentandSelectionMembers(
          allActiveSection[i - 1],
          currentCommits,
          seriesSelection,
          response
        );
        configState = response ? response.configState : configState;
      }
    }
    props.handleStartData(response);
    props.isLoading(false);
  };

  const hideLastSection = async (segment, response) => {
    //if series valve selection is commited, uncommit it before deleting
    var valveSelectionMember = currentSegmentSeriesSelectionMemberLocal(
      segment,
      response
    );
    var addSegmentMember = currentSegmentAddSegmentMember(segment, response);
    var configState = response.configState;
    if (valveSelectionMember.committed == true) {
      response = await unCommitAssemblyManifold(
        createRequest(
          {
            key: valveSelectionMember.name,
            isManifoldSegmentStepEdited: true,
            step: activeTab,
            activeTab: activeTab
          },
          configState
        )
      );

      configState = response ? response.configState : configState;
    }
    if (addSegmentMember.value == 'Yes') {
      response = await commitAssemblyManifold(
        createRequest(
          {
            key: addSegmentMember.name,
            value: 'No',
            isManifoldSegmentStepEdited: true,
            step: activeTab,
            activeTab: activeTab
          },
          configState
        )
      );
    }

    //remove the price segment list once it is deleted
    await handleRemovePrice(segment, response);
    return response;
  };

  const batchcommitSegmentandSelectionMembers = async (
    segment,
    segmentCommits,
    segmentSerieSelection,
    response
  ) => {
    var commitingMembers = [];

    if (!isSegmentCountDefined() && segmentSerieSelection.committed) {
      //get series selection member
      var valveSelectionMember = currentSegmentSeriesSelectionMemberLocal(
        segment,
        response
      );
      var valveSeriesValue = valveSelectionMember.domain.elements.filter(
        x =>
          x.description == segmentSerieSelection.valueDescription &&
          x.state == 'green'
      );
      if (valveSeriesValue.length > 0) {
        var currentActiveStations = allSegments(response);
        response = await commitAssemblyManifold(
          createRequest(
            {
              key: valveSelectionMember.name,
              value: valveSeriesValue[0].name,
              isManifoldSegmentStepEdited: true,
              step: activeTab,
              activeTab: activeTab
            },
            response.configState
          )
        );

        addEditedManifoldSegmentforPrice(
          segment.name,
          currentActiveStations,
          false
        );
      }
    }
    if (segmentCommits.length > 0) {
      //Get members of the specific section after copying the selection values
      segment = response?.segmentStep?.rootGroup?.members?.filter(
        x => x.name == segment.name
      )[0];
      var segmentUIMember = getSegmentSeriesUIMembers(segment);
      //Get commits from the members of the specific section.
      commitingMembers = getCommitingMembers(segmentUIMember, segmentCommits);
      if (commitingMembers.length > 0) {
        let requestData = {
          divisionId: sessionDataItems?.manufacturingDivision,
          productId: '',
          configState: response.configState,
          key: '',
          step: activeTab,
          activeTab: activeTab,
          configModel: sessionDataItems?.configModel,
          commits: commitingMembers,
          isManifoldSegmentStepEdited: isManifoldSegmentStepEdited
        };
        let res = await batchCommitProductMember(requestData);
        response = res ? res : response;
        setWorkstationEdited(segment.name, true);
      }
    }
    return response;
  };

  const getCommitingMembers = (allMembers, commitMembers) => {
    var commitingMemberArr = [];
    var commitMember;
    var data;
    var memberName;
    for (var j = 0; j < commitMembers.length; j++) {
      if (commitMembers[j].name.includes('_field_')) {
        var index = commitMembers[j].name.lastIndexOf('_');
        memberName = commitMembers[j].name.substring(0, index);
      } else memberName = commitMembers[j].name;
      data = allMembers.filter(x => x.name.includes(memberName));
      if (data.length > 0) {
        commitMember = { key: '', value: '' };
        commitMember['key'] = data[0].name;
        commitMember['value'] = commitMembers[j].value;
        commitingMemberArr.push(commitMember);
      }
    }
    return commitingMemberArr;
  };

  const onEditWorkstation = async name => {
    props.isLoading(true);
    handleIsStationEdit(true);
    setCurrentEditingStation(name);
    handleCurrentSegmentName(name);
    let configState = startData.configState;
    //commit series selection if not committed
    var segmentRootGroup = startData.segmentStep.rootGroup.members.filter(
      x => x.name == name
    )[0];
    let response = startData;

    let imageControlURLs = await getImageControls(segmentRootGroup, response);

    if (!isSegmentCountDefined()) {
      response = await commitSegmentValveSelection(
        segmentRootGroup,
        configState,
        response
      );

      response = await commitCurrentAddSegment(segmentRootGroup, response);
    }

    response.imageControlURLs = imageControlURLs;

    let members = currentWorkstationMembers(name, response);
    if (members.length <= 0) return;
    props.isLoading(false);
    setEditData(members);
    setTactonModel(response);
    props.handleStartData(response);
    setOpenEditModal(true);
  };

  const getImageControls = async (segment, response) => {
    var inputModel = [];
    var imageinput = {};
    let imageControlURLs;

    let members = getSegmentSeriesUIMembers(segment);
    var isImagecontrols = members.filter(
      x =>
        (x.properties['ph_image_field'] !== undefined &&
          x.properties['ph_image_field'] == 'yes') ||
        (x.properties['ph_link'] !== undefined && x.properties['ph_link'] != '')
    );
    if (isImagecontrols.length > 0) {
      var seriesUIGroup = getSegmentSeriesUIGroup(segment);

      imageinput.ManufacturingDivision = sessionDataItems.manufacturingLocation;
      imageinput.ConfigModel = seriesUIGroup[0].description;
      inputModel.push(imageinput);
      imageControlURLs = await getPossibleImages(inputModel);
    }
    return imageControlURLs;
  };

  const commitCurrentAddSegment = async (segment, response) => {
    var addSegmentMember = currentSegmentAddSegmentMember(segment, response);
    if (addSegmentMember && !addSegmentMember.committed) {
      if (
        addSegmentMember.domain.elements.filter(
          x => x.description == 'Yes' && x.state == 'green'
        ).length > 0
      ) {
        var currentActiveStations = allSegments(response);
        response = await commitAssemblyManifold(
          createRequest(
            {
              key: addSegmentMember.name,
              value: 'Yes',
              isManifoldSegmentStepEdited: isManifoldSegmentStepEdited,
              step: activeTab,
              activeTab: activeTab
            },
            response.configState
          )
        );

        addEditedManifoldSegmentforPrice(
          segment.name,
          currentActiveStations,
          false
        );
      }
    }
    return response;
  };

  //To get segment display members
  const currentWorkstationMembers = (name, response) => {
    var currentEditSegment = allSegments(response).filter(x => x.name == name);
    if (currentEditSegment.length == 0) return;
    var seriesUIGroup = getSegmentSeriesUIGroup(currentEditSegment[0]);
    if (seriesUIGroup.length == 0) {
      setOpenEditModal(false);
      setCurrentEditingStation('');
      return;
    }
    return seriesUIGroup[0].members;
  };

  const editCancelOnClick = async () => {
    props.isLoading(true);
    let configState = startData.configState;
    let response = startData;
    for (var i = 0; i < editedStationMembers.length; i++) {
      if (editedStationMembers[i].iscommit == true) {
        //commit the previous value if it is already commited before the update
        var currentActiveStations = allSegments(response);
        response = await commitAssemblyManifold(
          createRequest(
            {
              key: editedStationMembers[i].name,
              value: editedStationMembers[i].value,
              isManifoldSegmentStepEdited: false,
              step: activeTab,
              activeTab: activeTab
            },
            configState
          )
        );

        addEditedManifoldSegmentforPrice(
          currentEditingStation,
          currentActiveStations,
          false
        );

        configState = response ? response.configState : configState;
      } else {
        //uncommit the control if the value is just committed

        response = await unCommitAssemblyManifold(
          createRequest(
            {
              key: editedStationMembers[i].name,
              isManifoldSegmentStepEdited: true,
              step: activeTab,
              activeTab: activeTab
            },
            configState
          )
        );

        configState = response ? response.configState : configState;
      }
    }
    props.handleStartData(response);
    handleIsStationEdit(false);
    setOpenEditModal(false);
    setCurrentEditingStation('');
    props.isLoading(false);
    handleEditeStationMembers();
  };

  const onWorkstationSave = async () => {
    props.isLoading(true);
    var segmentRootGroup = startData.segmentStep.rootGroup.members.filter(
      x => x.name == currentEditingStation
    );
    var editedMembers = commitedUIMembers(segmentRootGroup[0]);
    if (editedMembers.length > 0) {
      setWorkstationEdited(currentEditingStation, true);
      var currentSegment = allSegments(startData).filter(
        x => x.name == currentEditingStation
      );
      if (currentSegment && currentSegment.length > 0) {
        var seriesSelection = currentSegmentSeriesSelectionMemberLocal(
          currentSegment[0],
          startData
        );
        if (seriesSelection) {
          let index = getIndex(getStepMembers(startData), seriesSelection);
          if (index > -1) {
            window['dataLayer'].push({
              event: 'facet_products',
              facet_category: currentSegment[0].description,
              facet_category_pos: index,
              facet_sub_category: 'N/A',
              facet_sub_category_pos: 'N/A',
              product_category_name: sessionDataItems.breadCrumbText2
                ? sessionDataItems.breadCrumbText2
                : 'N/A',
              product_series_name: sessionDataItems.seriesName,
              product_series_id: sessionDataItems.productId
            });

            handleSetCommits(
              SetCommitsName(
                commits,
                currentSegment[0].description,
                index,
                startData
              )
            );
          }
        }
      }
    }
    setOpenEditModal(false);
    handleIsStationEdit(false);
    handleEditeStationMembers();
    //calcuate the price on save instead of calculating during each selection
    let editedSegments = [
      ...editedManifoldSegmentforPrice,
      currentEditingStation
    ];
    var currentActiveStations = allSegments(startData);
    addEditedManifoldSegmentforPrice(
      currentEditingStation,
      currentActiveStations,
      false
    );
    if (sessionDataItems.option == '100')
      await handleManifoldPrices(editedSegments.filter(x => x !== ''));

    setCurrentEditingStation('');
    props.isLoading(false);
  };

  const isModuleStationConfigured = () => {
    if (editedWorkStation.length > 0) {
      let filteredWorkStation = editedWorkStation.filter(
        x => x.value === false
      );
      if (filteredWorkStation.length > 0) return false;
    } else {
      return false;
    }
    return true;
  };

  const onDuplicateWorkstationClick = async stationName => {
    props.isLoading(true);
    var allActiveStations = allSegments(startData); //get all available work sections
    var startIndex = allActiveStations.findIndex(x => x.name === stationName); //get index of duplicating work section
    var previousCommits = [];
    var currentUIandSelectionCommits = [];
    var currentCommits = [];
    var prevSeriesSelection;
    var currSeriesSelection;
    let response = startData;
    handleIsCADValueChanged(true);
    //When the user clicks on the last/bottom visible section on screen
    var IsthislastsectionOnScreen = allActiveStations.length == startIndex + 1;
    if (IsthislastsectionOnScreen) {
      var lastCommits = commitedUIMembers(
        allActiveStations[allActiveStations.length - 1]
      );
      var lastSeriesSelection = currentSegmentSeriesSelectionMemberLocal(
        allActiveStations[allActiveStations.length - 1],
        response
      );
      if (lastSeriesSelection) {
        response = await duplicateLastStation(
          lastCommits,
          lastSeriesSelection,
          response
        );
      }
    } else {
      for (var i = startIndex; i < allActiveStations.length; i++) {
        currentUIandSelectionCommits = [];
        //This is the section that user has clicked "Duplicate" on screen.
        var IsthisSectiontoduplicate = i == startIndex;

        //During duplication, we would reach the last section on screen to duplicate.
        //In that case, we need to show/create a new section and then copy/duplicate the previous section commits.
        var IsItthelastSectionOnScreenToDuplicate =
          i == allActiveStations.length - 1;

        //When we duplicate a section in between the visible sections, then we store the commits/selections of that section in "previousCommits"
        //We will use these commits to duplicate the next section.
        if (IsthisSectiontoduplicate) {
          previousCommits = commitedUIMembers(allActiveStations[i]);
          if (!isSegmentCountDefined())
            prevSeriesSelection = currentSegmentSeriesSelectionMemberLocal(
              allActiveStations[i],
              response
            );
          continue;
        }

        currentCommits = commitedUIMembers(allActiveStations[i]);
        currentUIandSelectionCommits.push(...currentCommits);
        if (!isSegmentCountDefined()) {
          currSeriesSelection = currentSegmentSeriesSelectionMemberLocal(
            allActiveStations[i],
            response
          );

          if (currSeriesSelection.committed)
            currentUIandSelectionCommits.push(currSeriesSelection);
        }

        if (currentUIandSelectionCommits.length > 0) {
          let requestData = {
            divisionId: sessionDataItems?.manufacturingDivision,
            productId: '',
            configState: response?.configState,
            key: '',
            configModel: sessionDataItems?.configModel,
            commits: currentUIandSelectionCommits.map(x => x.name),
            step: activeTab,
            activeTab: activeTab //,
            //tactonModel: response.tactonModel
          };
          let res = await batchUncommit(requestData);
          response = res ? res : response;
          // await configuratorService.batchUncommit({ commits: currentUIandSelectionCommits.map(x => x.name) });
          if (currentCommits.length > 0)
            handleDeleteSegmentEdited(allActiveStations[i].name);
        }
        //apply the current commits/selections to next segment
        response = await batchcommitSegmentandSelectionMembers(
          allActiveStations[i],
          previousCommits,
          prevSeriesSelection,
          response
        );
        previousCommits = currentCommits;
        prevSeriesSelection = currSeriesSelection;
        if (IsItthelastSectionOnScreenToDuplicate && !isSegmentCountDefined()) {
          //Create/show a new section
          //Duplicate/apply the current commits/selections to the newly created/showed section.
          response = await duplicateLastStation(
            currentCommits,
            currSeriesSelection,
            response
          );
        }
      }
    }
    props.handleStartData(response);
    props.isLoading(false);
  };

  const duplicateLastStation = async (
    lastCommits,
    seriesSelection,
    response
  ) => {
    //Add next segment/station
    response = await addNewStation(response);
    var availableSegments = allSegments(response);
    //if valve size selection member from the previous segment is commited, commit the valve size selection member of newly added section and commits if any
    response = await batchcommitSegmentandSelectionMembers(
      availableSegments[availableSegments.length - 1],
      lastCommits,
      seriesSelection,
      response
    );
    return response;

    //await this.CommitRestrictionAddressforHSeries();
  };

  const addEditedManifoldSegmentforPrice = (
    segmentName,
    currentActiveStations,
    isAdd
  ) => {
    if (!isStationEdit && segmentName) {
      handleEditedManifoldSegmentforPrice(
        segmentName,
        currentActiveStations,
        isAdd
      );
    }
  };

  const clearSelections = () => {
    handleOnChange('', 'resetall', '');
    setSelectedOption(0);
    handleEditedWorkStation('', '', true);
    handleIsCADValueChanged(true);
  };

  const isSegmentCountDefined = () => {
    let members = startData?.uiGroup?.members;
    if (
      members.filter(
        x => x.properties && x.properties['ph_segment_count'] == 'yes'
      ).length > 0
    )
      return true;
    else return false;
  };

  const createRequest = (data, configState) => {
    let requestData = {
      divisionId: sessionDataItems?.manufacturingDivision,
      configState: configState ? configState : startData.configState,
      configModel: sessionDataItems?.configModel,
      ...data
    };
    return requestData;
  };

  const isDuplicateButtonEnable = segmentName => {
    if (segmentDuplicateStatus?.length > 0) {
      if (segmentDuplicateStatus?.filter(x => x.name == segmentName).length > 0)
        return segmentDuplicateStatus?.filter(x => x.name == segmentName)[0]
          .isDuplicate;
      else return false;
    }
    return false;
  };

  return (
    <>
      {openEditModal && (
        <EditModalManifold
          open={openEditModal}
          handleClose={onWorkstationSave}
          handleCancel={editCancelOnClick}
          handleOnChange={handleOnChange}
          data={editData}
          lang={props.lang}
          startData={tactonModel}
          sessionDataItems={sessionDataItems}
          stepName={currentEditingStation}
        />
      )}

      <Grid container>
        <Grid className="dynamic-stack-option">
          <Box
            className="headBoxLeft"
            sx={
              selectedOption == 0
                ? {
                    border: '1px solid #ffb91d',
                    borderBottom: '4px solid #ffb91d'
                  }
                : {}
            }
            onClick={() => onManifoldValeOptionsClick()}
          >
            <Typography className="headText">
              {startData?.manifoldStep?.description}
            </Typography>
          </Box>
          <Box
            className="headBoxLeft"
            sx={
              selectedOption == 1
                ? {
                    border: '1px solid #ffb91d',
                    borderBottom: '4px solid #ffb91d'
                  }
                : {}
            }
            onClick={() => onValveStationClick()}
          >
            <Typography className="headText">
              {startData?.segmentStep?.description}
            </Typography>
            {isModuleStationConfigured() ? (
              <CheckCircleRoundedIcon className="green-check-segment" />
            ) : (
              <RemoveCircleRoundedIcon className="remove-circle-segment" />
            )}
          </Box>
        </Grid>

        {!isVE && (
          <Grid
            item
            xs={12}
            sm={12}
            md={selectedOption == 0 ? 12 : 6}
            lg={selectedOption == 0 ? 12 : 6}
          >
            <a className="clear-selections" onClick={() => clearSelections()}>
              <ReplayIcon className="replay-icon-clear" />
              {props.lang.RESET_SELECTIONS_TO_BASE_MODEL}
            </a>
          </Grid>
        )}
        {selectedOption == 1 && (
          <Grid
            item
            xs={12}
            sm={12}
            md={selectedOption == 0 ? 12 : 6}
            lg={selectedOption == 0 ? 12 : 6}
            className="align-center"
          >
            {canAddWorkStation() && (
              <RoundButton
                name={
                  <>
                    <AddRoundedIcon className="add-rounded-icon" />
                    {props.lang?.ADD_STATION}
                  </>
                }
                classname="add-station"
                onClick={() => onAddStationClick()}
              />
            )}
          </Grid>
        )}

        {selectedOption == 0 && (
          <div className="options-content">
            {startData?.uiGroup?.members?.map((member, index) => {
              return (
                <div key={member.name + '_' + index}>
                  <MemberComponent
                    member={member}
                    startData={startData}
                    handleOnChange={handleOnChange}
                    sessionDataItems={sessionDataItems}
                    stepName={getManifoldStepName()}
                    lang={lang}
                  />
                </div>
              );
            })}
          </div>
        )}

        {selectedOption == 1 && (
          <div className="options-content">
            {allSegments(startData).map((workstation, index) => {
              return (
                <Grid key={workstation.name} className="work-section">
                  <Typography className="headText">
                    {workstation.description}
                    {hasWorkstationEdits(workstation.name) ? (
                      <CheckCircleRoundedIcon className="green-check" />
                    ) : (
                      <RemoveCircleRoundedIcon className="remove-circle" />
                    )}
                  </Typography>
                  {currentSegmentSelectionMembers(workstation, startData).map(
                    (member, index) => {
                      return (
                        <div key={member.name + '_' + index}>
                          <MemberComponent
                            member={member}
                            startData={startData}
                            handleOnChange={handleOnChange}
                            sessionDataItems={sessionDataItems}
                            stepName={workstation.name}
                            lang={lang}
                          />
                        </div>
                      );
                    }
                  )}
                  {ifCurrentWorkStationHaveMembers(workstation) && (
                    <div>
                      {stationPartnumber(workstation).map(member => {
                        return (
                          <Typography className="headText" key={member.name}>
                            {member.description}: {member.value}
                          </Typography>
                        );
                      })}
                      {!isVE && (
                        <RoundButton
                          name={props.lang?.EDIT}
                          classname="edit-station"
                          onClick={() => onEditWorkstation(workstation.name)}
                        />
                      )}
                      {isDuplicateButtonEnable(workstation.name) && (
                        <RoundButton
                          name={props.lang?.DUPLICATE}
                          classname="edit-station"
                          onClick={() =>
                            onDuplicateWorkstationClick(workstation.name)
                          }
                        />
                      )}
                      {canDeleteWorkstations() && (
                        <RoundButton
                          name={props.lang?.DELETE}
                          classname="edit-station"
                          onClick={() => onDeleteWorkstationClick(workstation)}
                        />
                      )}
                    </div>
                  )}
                  {endSegment(workstation) && <hr />}
                  {endSegment(workstation)?.map((member, index) => {
                    return (
                      <div key={member.name + '_' + index}>
                        <MemberComponent
                          member={member}
                          startData={startData}
                          handleOnChange={handleOnChange}
                          sessionDataItems={sessionDataItems}
                          stepName="manifold"
                          lang={lang}
                        />
                      </div>
                    );
                  })}
                </Grid>
              );
            })}
          </div>
        )}
      </Grid>
    </>
  );
}

export default ManifoldAssemblyNav;
